import { SvgProps } from '@tymbe/components/icons';

export const EditIcon = ({ className = '', ...props }: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={`${className}`}
  >
    <path
      d="M1.99917 11.6409V13.6676C1.99917 13.8543 2.14584 14.0009 2.3325 14.0009H4.35917C4.44583 14.0009 4.5325 13.9676 4.5925 13.9009L11.8725 6.6276L9.3725 4.1276L2.09917 11.4009C2.0325 11.4676 1.99917 11.5476 1.99917 11.6409ZM13.8058 4.69427C14.0658 4.43427 14.0658 4.01427 13.8058 3.75427L12.2458 2.19427C11.9858 1.93427 11.5658 1.93427 11.3058 2.19427L10.0858 3.41427L12.5858 5.91427L13.8058 4.69427Z"
      fill="#959CC0"
    />
  </svg>
);
